/* eslint-disable react/prop-types */
import React, { Component, useEffect, useState } from "react";
import Select from "react-select";
import Modal from "react-awesome-modal";
import "bootstrap/dist/css/bootstrap.min.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import { useHistory } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import FormControl from "@material-ui/core/FormControl";
import CustomInput from "components/CustomInput/CustomInput";
import Button from "components/CustomButtons/Button";
import Constants from "variables/Constants";
import Grid from "@material-ui/core/Grid";
import "./NewAddCourseMaster.css";
import { MultiSelect } from "react-multi-select-component";

// import editorConfiguration from "../variables/EditorConfiguration";
//import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
// import { MultiSelect } from "react-multi-select-component";
// Inside src/index.js or src/App.js

let ProgressBar = (props) => {
  return (
    <div className="progress-bar">
      <Filler percentage={props.percentage} />
    </div>
  );
};
let Filler = (props) => {
  return (
    <div className="filler" style={{ width: `${props.percentage}%` }}></div>
  );
};
let fd = new FormData();
const facultyIds = [];

const NewAddCourseMaster = () => {
  const history = useHistory();
  const token = localStorage.getItem("accessToken");

  const [category, setCategory] = useState("");
  const [title, setTitle] = useState("");
  const [sku, setSku] = useState("");
  const [duration, setDuration] = useState("");
  const [faculty, setFaculty] = useState([]);
  const [facultyWithName, setFacultyWithName] = useState("");
  const [vendorCommission, setVendorCommission] = useState(0);
  const [facultyCommission, setFacultyCommission] = useState(0);
  const [facultyId, setFacultyId] = useState("");
  const [facultyArr, setFacultyArr] = useState([]);
  const [levels, setLevels] = useState([]);
  const [cod, setCod] = useState("");
  const [akshare, setAkshare] = useState(100);
  const [facultyshare, setFacultyshare] = useState("");
  const [proDesc, setProDesc] = useState("");
  const [courseDetails, setCourseDetails] = useState("");
  const [specification, setSpecification] = useState("");
  const [productId, setProductId] = useState("");
  const [googlesheetdetails, setGooglesheetdetails] = useState("");
  const [index, setIndex] = useState([]);
  const [img, setImg] = useState(null);
  const [confirmation, setConfirmation] = useState(["Yes", "No"]);
  const [confirm, setConfirm] = useState("No");
  const [testSeries, setTestSeries] = useState([]);
  const [test, setTest] = useState([]);
  const [thumb, setThumb] = useState([]);
  const [cashback, setCashback] = useState("");
  const [discount, setDiscount] = useState("");
  const [gcLink, setGcLink] = useState("");
  const [gwLink, setGwLink] = useState("");
  const [gaLink, setGaLink] = useState("");
  const [demoLink1, setDemoLink1] = useState("");
  const [demoLink2, setDemoLink2] = useState("");
  const [demoLink3, setDemoLink3] = useState("");
  const [demoLink4, setDemoLink4] = useState("");
  const [offValue, setOffValue] = useState("");
  const [subject, setSubject] = useState("");
  const [offType, setOffType] = useState("");
  const [payment_gateway, setPayment_gateway] = useState("");
  const [offTypeArray, setOffTypeArray] = useState(["percent", "amount"]);
  const [paymentGatewayArray, setPaymentGatewayArray] = useState([
    "razorpay",
    "phonepe",
  ]);
  const [courses, setCourses] = useState([]);
  const [attempts, setAttempts] = useState([]);
  const [batches, setBatches] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [atLeast, setAtLeast] = useState(false);
  const [notification, setNotification] = useState(false);
  const [displayVariant, setDisplayVariant] = useState(false);
  const [gatewayAlert, setGatewayAlert] = useState(false);
  const [aAlert, setAAlert] = useState(false);
  const [bAlert, setBAlert] = useState(false);
  const [cAlert, setCAlert] = useState(false);
  const [dAlert, setDAlert] = useState(false);
  const [visible, setVisible] = useState(false);
  const [eAlert, setEAlert] = useState(false);
  const [fAlert, setFAlert] = useState(false);
  const [TestSeriesAlert, setTestSeriesAlert] = useState(false);
  const [langAlert, setLangAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [batchAlert, setBatchAlert] = useState(false);
  const [languages, setLanguages] = useState(["Hindi", "English"]);
  const [language, setLanguage] = useState("");
  const [dropShow, setDropShow] = useState(false);
  const [type, setType] = useState(["Normal", "Combo"]);
  const [combo_type, setCombo_type] = useState("");
  const [batch, setBatch] = useState([]);
  const [batchwings, setBatchwings] = useState([]);

  const [batch_wings, setBatch_wings] = useState([]);
  const [batch_id, setBatch_id] = useState([]);
  const [attempt, setAttempt] = useState("");
  const [getSubjectFilter, setGetSubjectFilter] = useState([]);
  const [level, setLevel] = useState("");
  const [streams, setStreams] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [subjectFilterOptions, setSubjectFilterOptions] = useState([]);
  const [subject_filter_id, setSubject_filter_id] = useState(0);
  const [test_seriesId, setTest_seriesId] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [selected_amenites, setSelected_amenites] = useState([]);
  const [amenity_id_array, setAmenity_id_array] = useState([]);
  const [ordermailtemplate, setOrdermailtemplate] = useState("");
  const [shippingmailtemplate, setShippingmailtemplate] = useState("");
  const [orderTemplates, setOrderTemplates] = useState([]);
  const [shippingTemplates, setShippingTemplates] = useState([]);
  const [submittedData, setSubmittedData] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [secondFormEntries, setSecondFormEntries] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [requiredFields, setRequiredFields] = useState(false);
  const [editVariantId, setEditVariantId] = useState(null);
  const [variantArray, setVariantArray] = useState([]);
  const [variants, setVariants] = useState([]);
  const [attemptOptions, setAttemptOptions] = useState([]);
  const [facultyIds, setFacultyIds] = useState([]);
  const [imgPreview, setImgPreview] = useState(null);

  const [testSeriesOptions, setTestSeriesOptions] = useState([]);
  const [formData, setFormData] = useState({
    combo_type: "",
    subjects: [],
    subjectFilters: [],
    attempt: "",
    batchwings: "",
    batch: [],
    sku: "",
    title: "",
    duration: "",
    akshare: "",
    payment_gateway: "",
    ordermailtemplate: "",
    shippingmailtemplate: "",
    language: "",
    testSeries: "",
    selectedSeriesId: "",
    cashback: "",
    demoLink1: "",
    demoLink2: "",
    demoLink3: "",
    demoLink4: "",
    googlesheetdetails: "",
    short_description: "",
    demoLink: "",
    discount: "",
    value: "",
    offer_type: "",
    faculty: [],
    facultyWithName: "",
    vendorCommission: 0,
    facultyCommission: 0,
    facultyId: "",
    facultyArr: [],
    facultyshare: "",
    apple_product_id: "",
    apple_id: "",
    selectedColor: "#000000",
    amenitiesIds: [],
    amenitiesDetails: [],
    selected_amenities: [],
  });

  const [secondFormData, setSecondFormData] = useState({
    attempt_id: "",
    price: "",
    sku: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setOrderTemplates([]);
      setShippingTemplates([]);

      const [orderRes, shippingRes] = await Promise.all([
        axios.get(`${Constants.getUrls.getmailTemplate}?type=Order`),
        axios.get(`${Constants.getUrls.getmailTemplate}?type=Shipping`),
      ]);

      console.log("Order Res", orderRes.data.data);
      console.log("Shipping Res", shippingRes.data.data);

      setOrderTemplates(orderRes.data.data);
      setShippingTemplates(shippingRes.data.data);

      const coursesRes = await axios.get(
        "https://admin.akclasses.in/api/courseCategoriesR",
      );
      console.log("Course Data", coursesRes.data);
      setCourses(coursesRes.data);

      const amenitiesRes = await axios.get(
        `${Constants.getUrls.getAmenities}?per_page=150`,
      );
      console.log("Amenities", amenitiesRes.data.data);

      // const amenitiesData = amenitiesRes.data.data.map((val) => ({
      //   title: val?.title,
      //   id: val?.id,
      // }));
      setAmenities(amenitiesRes.data.data);

      const testSeriesRes = await axios.get(
        "https://admin.akclasses.in/api/courses?type=Test_Series&per_page=10",
      );
      console.log("Series", testSeriesRes.data.data);

      const testSeriesData = testSeriesRes.data.data.map((val) => ({
        label: val?.TITLE,
        value: val?.ID,
      }));
      setTestSeries(testSeriesData);

      const facultyRes = await axios.get(
        "https://admin.akclasses.in/api/facultyR",
      );
      console.log("Faculty", facultyRes.data);
      setFacultyArr(facultyRes.data);

      // If you want to enable batchWings API later
      const batchwings = await axios.get(
        "https://admin.akclasses.in/api/batchWings?per_page=10&is_deleted=0",
      );
      console.log(batchwings);
      setBatchwings(batchwings.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleBatch = (e) => {
    setBatch(e.target.value);
  };

  // const handleFile = (e) => {
  //   const { name, files } = e.target;

  //   if (name === "img") {
  //     setImg(files[0]);
  //   } else if (name === "codPdf") {
  //     setCodPdf(files[0]);
  //   }
  //   // add more conditions if other file inputs exist
  // };

  const openModal = () => {
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  const handleAttempt = (e) => {
    const selectedValue = e.target.value;
    setAttempt(selectedValue); // If you're still using this state
    setFormData((prev) => ({
      ...prev,
      attempt: selectedValue, // ✅ update formData
    }));
    setAAlert(false);
  };

  const handleLevel = async (e) => {
    const { name, value } = e.target;

    if (name === "category") {
      setCategory(value);
    }

    setAAlert(false);

    try {
      const resp = await axios.get(
        `https://admin.akclasses.in/api/showCategory_with_level/${value}`,
      );
      console.log("Level Data", resp.data);
      setLevels(resp.data.level);
    } catch (error) {
      console.error("Error fetching levels:", error);
    }
  };

  const handleStream = async (e) => {
    const { name, value } = e.target;
    setCAlert(false);
    setLevel(value);

    try {
      const { data } = await axios.get(
        `https://admin.akclasses.in/api/level/${value}`,
      );
      setStreams(data.stream);
    } catch (error) {
      console.error("Error fetching streams:", error);
    }
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const staticStreamId = 1; // Replace with the actual stream ID you want to use
        const { data } = await axios.get(
          `https://admin.akclasses.in/api/stream/${staticStreamId}`,
        );
        console.log("STATIC SUBJECTS", data.stream.subject_masters);
        setSubjects(data.stream.subject_masters);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };

    fetchSubjects();
  }, []);

  useEffect(() => {
    const fetchAttempts = async () => {
      try {
        const res = await axios.get(
          "https://admin.akclasses.in/api/activeAttempts",
        );
        if (res?.data) {
          setAttemptOptions(res.data);
        }
      } catch (err) {
        console.error("Error fetching attempt options:", err);
      }
    };

    fetchAttempts();
  }, []);

  const handleWings = async (e) => {
    const { name, value } = e.target;
    setFAlert(false);
    setSubject(value);

    try {
      const { data } = await axios.get(
        `${Constants.getUrls.subjectFilter}?subject_id=${value}`,
      );
      setGetSubjectFilter(data[0]);
    } catch (error) {
      console.error("Error fetching subject filter:", error);
    }
  };
  const handleSubjectFilter = async (selectedSubjects) => {
    setSubject(selectedSubjects); // Store multiple selected subjects

    try {
      const filters = [];

      // Loop through selected subject IDs
      for (const id of selectedSubjects) {
        const { data } = await axios.get(
          `${Constants.getUrls.subjectFilter}?subject_id=${id}`,
        );

        if (Array.isArray(data) && data.length > 0) {
          const filtered = data[0].filter(
            (item) => item.subject_id === parseInt(id),
          );
          filters.push(...filtered);
        }
      }

      setSubjectFilterOptions(filters);

      const attemptsRes = await axios.get(
        "https://admin.akclasses.in/api/activeAttempts",
      );
      console.log("Attempts", attemptsRes.data);
      setAttempts(attemptsRes.data);
    } catch (error) {
      console.error("Error fetching subject filter:", error);
      setSubjectFilterOptions([]);
    }
  };

  const attemptWiseWings = async (e) => {
    const { name, value } = e.target;
    setSubject(value);

    try {
      const { data } = await axios.get(
        `https://admin.akclasses.in/api/subjectWings/${value}`,
      );
      setBatch_wings(data.wings);
    } catch (error) {
      console.error("Error fetching attempt wise wings:", error);
    }
  };
  const fetchBatches = async (wingId) => {
    try {
      const { data } = await axios.get(
        `https://admin.akclasses.in/api/wingBatch/${wingId}`,
      );
      const tempBatches = data.data.map((item) => ({
        label: item.batch?.batch_name || "Unnamed Batch",
        value: item.batch?.id || "",
      }));

      setBatches(tempBatches);
    } catch (error) {
      console.error("Error fetching batches:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === "batchwings") {
      fetchBatches(value); // pass the selected wing ID
    }
  };

  if (!token) {
    console.log("Token not found. Please login again.");
    return;
  }

  const handleSubmit1 = async (e) => {
    e.preventDefault();

    if (
      selectedSubjects?.length === 0 ||
      !formData?.language ||
      !formData?.payment_gateway
    ) {
      setRequiredFields(true);
      return;
    }

    try {
      setRequiredFields(false);

      const fd = new FormData();
      console.log("Selected Subjects:", selectedSubjects);
      console.log("Selected subjects before submit: ", formData.subjects);

      const productData = {
        product_id: formData?.apple_product_id,
        apple_id: formData?.apple_id,
      };

      const COMMON_GD_LINK = JSON.stringify(productData);

      // const COMMON_GD_LINK = `{product_id:"${formData?.apple_product_id}", apple_id:"${formData?.apple_id}"}`;

      fd.append("faculty", "1");
      fd.append("ak_share", formData?.akshare);
      fd.append("discount_amount", formData?.discount);
      fd.append("cash_amount", formData?.cashback);
      fd.append("category", category);
      fd.append("sku", 101);
      fd.append("title", formData?.title);
      fd.append("short_description", formData?.short_description);
      fd.append("description", courseDetails);
      // fd.append("description", proDesc);
      fd.append("duration", formData?.duration);
      fd.append("price", " ");
      fd.append("combo_type", formData?.combo_type);
      fd.append("price_1", " ");
      fd.append("image_path", img);
      console.log("imagePath", img);
      fd.append("thumb_image", img);
      console.log("Thumb Image", img);
      // fd.append("what_learn", specification);
      fd.append("what_learn", formData?.selectedColor);
      fd.append("syllabus_pdf", index);
      // fd.append("common_link", gcLink);
      fd.append("common_link", COMMON_GD_LINK);

      fd.append("window_link", gwLink);
      fd.append("android_link", gaLink);
      fd.append("demo_link", formData?.demoLink1);
      fd.append("demo_link1", formData?.demoLink2);
      fd.append("demo_link2", formData?.demoLink3);
      fd.append("demo_link3", formData?.demoLink4);
      fd.append("google_sheet_details", formData?.googlesheetdetails);
      fd.append("level", " ");
      fd.append("stream", " ");
      fd.append("offer_type", formData?.offer_type);
      fd.append("payment_gateway", formData?.payment_gateway);
      fd.append("ordermailtemplate", formData?.ordermailtemplate);
      fd.append("shippingmailtemplate", formData?.shippingmailtemplate);
      fd.append("language", formData?.language);
      // fd.append("common_link", COMMON_GD_LINK);

      //fd.append("subject_master_id", selectedSubjects);
      fd.append("subject_filter_ids", selectedFilter);

      formData.subjects.forEach((subjectId) => {
        fd.append("subject_ids[]", subjectId);
      });
      formData.subjectFilters.forEach((subjectFilters) => {
        fd.append("subject_filter_ids[]", subjectFilters);
      });
      fd.append("value", formData?.value);
      fd.append("curriculum_doubts", " ");
      fd.append("curriculum_doubts_pdf", " ");
      fd.append("type", "COURSES");
      fd.append("faculty_detail", JSON.stringify(faculty));
      fd.append("batch_wings_id", formData.batchwings);

      formData.batch.forEach((id) => {
        fd.append("batch_id[]", id); // Notice the [] to indicate array
      });

      fd.append("attempt", 2025);

      if (formData.testSeries === "Yes" && formData.selectedSeriesId) {
        fd.append("include_test_series", formData.selectedSeriesId);
      } else {
        fd.append("include_test_series", null); // You can append empty or null depending on backend validation
      }
      // fd.append("amenity_details", formData.amenitiesDetails);
      fd.append(
        "amenity_details",
        JSON.stringify(formData.amenitiesDetails) || [],
      );
      // fd.append("amenity_ids", formData.amenitiesIds.join(",") || " ");
      // fd.append(
      //   "amenity_ids",
      //   Array.isArray(formData?.amenitiesIds) &&
      //     formData.amenitiesIds.length > 0
      //     ? formData.amenitiesIds.join(",")
      //     : " ",
      // );

      fd.append(
        "amenity_ids",
        JSON.stringify(
          formData.selected_amenities.map((item) => item.value) || " ",
        ),
      );
      for (let [key, value] of fd.entries()) {
        console.log(`${key}:${value}`);
      }

      const res = await axios.post(
        "https://admin.akclasses.in/api/course/create",
        fd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res) {
        console.log("COURSE ADDED Successcfully ", res);
        console.log("Product ID", res?.data?.data?.ID);
        setProductId(res?.data?.data?.ID);
        //getCourseVariant(res?.data?.data?.ID);
        setIsSubmitted(true);
      }

      // const productID = response?.data?.productID;

      // if (productID) {
      //   setProductId(productID);
      // }
    } catch (error) {
      console.log("Error while adding course", error);
    }

    // setSubmittedData(formData);
    // setIsSubmitted(true);
  };

  const handleSecondFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const fd = new FormData();
      fd.append("sku", secondFormData?.sku);
      fd.append("price", secondFormData?.price);
      fd.append("attempt_id", secondFormData?.attempt_id);

      let res;

      if (editVariantId) {
        // 🔄 Updating an existing variant
        res = await axios.post(
          `https://admin.akclasses.in/api/variant/updateNew/${editVariantId}`,
          fd,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );
      } else {
        // ➕ Creating a new variant
        res = await axios.post(
          `https://admin.akclasses.in/api/variant/createNew/${productId}`,
          fd,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );
      }

      if (res?.data?.status === "success") {
        console.log("Variant saved successfully");

        // 🔄 Refresh variant list
        getCourseVariant(productId);

        // Reset form
        setSecondFormData({
          attempt_id: "",
          sku: "",
          price: "",
        });
        setEditVariantId(null); // Clear edit mode
        setEditIndex(null);
      } else {
        console.log("Failed to save variant", res?.data);
      }
    } catch (error) {
      console.log("Error while saving variant", error);
    }
  };

  const subjectOptions = subjects.map((sub) => ({
    value: sub.subject_master.id,
    label: sub.subject_master.title,
  }));

  const handleSecondInputChange = (e) => {
    const { name, value } = e.target;
    setSecondFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEdit = (index) => {
    const entry = variants[index];
    setEditIndex(index);
    setEditVariantId(entry.id);

    setSecondFormData({
      attempt_id: entry.attempt_id || "", // ✅ use attempt_id
      sku: entry.sku || "",
      price: entry.price || "",
    });
  };

  const handleCancel = () => {
    setEditIndex(null);
    setSecondFormData({
      attempt_id: "",
      sku: "",
      price: "",
    });
  };

  const handleCancel1 = () => {
    history.goBack(); // Go to the previous page
  };
  const getCourseVariant = async (id) => {
    try {
      const response = await axios.get(
        `https://admin.akclasses.in/api/course/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const variantData = response.data?.product?.variant || [];
      setVariants(variantData);
    } catch (error) {
      console.log("Error fetching variant data:", error);
    }
  };
  const handleFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImg(file);
      setImgPreview(URL.createObjectURL(file)); // for preview
    }
  };

  const handleDelete = async (variantId) => {
    try {
      const res = await axios.post(
        `https://admin.akclasses.in/api/variant/delete/${variantId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // include if required
          },
        },
      );

      if (res.status === 200) {
        // Filter out the deleted variant from state
        const updatedVariants = variants.filter((v) => v.id !== variantId);
        setVariants(updatedVariants);
        console.log("Variant deleted successfully.");
      } else {
        console.error(
          "Failed to delete variant. Server responded with:",
          res.status,
        );
      }
    } catch (error) {
      console.error("Error deleting variant:", error);
    }
  };
  const handleMultiSelectChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map(
      (option) => option.value,
    );
    setFormData({ ...formData, batch: selectedOptions });
  };

  //Add Faculty
  const handleAdd = () => {
    console.log("Add Faculty Clicked");

    if (!facultyId || !facultyshare) {
      console.log("Missing fields:", { facultyId, facultyshare });
      setBAlert(true);
      return;
    }

    if (!facultyIds.includes(facultyId)) {
      const selectedFaculty = facultyArr.find(
        (f) => parseInt(f.id) === parseInt(facultyId),
      );

      if (!selectedFaculty) {
        console.log("Selected faculty not found for ID:", facultyId);
        return;
      }

      console.log("Selected Faculty:", selectedFaculty);

      const updatedFaculty = [
        ...faculty,
        {
          fid: facultyId,
          fName: selectedFaculty.name,
          fshare: parseFloat(facultyshare),
        },
      ];

      console.log("Updated Faculty List:", updatedFaculty);

      setFaculty(updatedFaculty);
      setFacultyIds([...facultyIds, facultyId]);
      setFacultyshare("");
      setFacultyId("");

      const newCommission = updatedFaculty.reduce(
        (acc, cur) => acc + cur.fshare,
        0,
      );
      console.log("New Commission:", newCommission);

      setFacultyCommission(newCommission);
      setAkshare(100 - newCommission);
      setAtLeast(updatedFaculty.length === 0);
    } else {
      console.log("Faculty already added:", facultyId);
    }

    setVisible(false);
  };
  const headerStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px black solid",
    borderCollapse: "collapse",
  };

  const cellStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px black solid",
    borderCollapse: "collapse",
  };

  // Handle initial dropdown change (Yes/No) for testseries
  const handleInputChangeTestSeries = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      selectedSeriesId: "", // reset selection when switching Yes/No
    }));

    if (value === "Yes") {
      fetchTestSeriesOptions();
    } else {
      setTestSeriesOptions([]);
    }
  };

  const fetchTestSeriesOptions = async () => {
    try {
      const response = await axios.get(
        "https://admin.akclasses.in/api/courses?type=Test_Series&per_page=10",
      ); // replace with actual endpoint
      const formatted = response.data?.data?.map((item) => ({
        id: item.ID,
        title: item.TITLE,
      }));
      setTestSeriesOptions(formatted || []);
    } catch (error) {
      console.error("Error fetching test series:", error);
    }
  };
  // Handle selection of test series course
  const handleSeriesSelection = (e) => {
    setFormData((prev) => ({
      ...prev,
      selectedSeriesId: e.target.value,
    }));
  };

  const handleAmenityChange = (amenity) => {
    setFormData((prev) => {
      const alreadySelected = prev.amenitiesIds.includes(amenity.id);

      if (alreadySelected) {
        return {
          ...prev,
          amenitiesIds: prev.amenitiesIds.filter((id) => id !== amenity.id),
          amenitiesDetails: prev.amenitiesDetails.filter(
            (item) => item.id !== amenity.id,
          ),
        };
      } else {
        return {
          ...prev,
          amenitiesIds: [...prev.amenitiesIds, amenity.id],
          amenitiesDetails: [...prev.amenitiesDetails, amenity],
        };
      }
    });
  };

  return (
    <div className="container-one">
      <div className="container-two">
        <form onSubmit={handleSubmit1} className="container-form">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="form-group mt-3 text-dark">
                <label class="text-dark" htmlFor="simple-select ">
                  Course Type
                </label>
                <select
                  className="form-control"
                  id="simple-select"
                  name="combo_type"
                  value={formData.combo_type}
                  onChange={handleInputChange} // ✅ this updates formData correctly
                >
                  <option value="">Select Course Type</option>
                  {type.map((v, i) => (
                    <option key={i} value={v}>
                      {v}
                    </option>
                  ))}
                </select>
              </div>

              {aAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4 container-two">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="subject-select text-dark">
                  Subject
                </label>
                <Select
                  isMulti
                  name="subjects"
                  options={subjectOptions}
                  value={subjectOptions.filter((opt) =>
                    selectedSubjects.includes(opt.value),
                  )}
                  onChange={(selectedOptions) => {
                    let selectedValues = selectedOptions.map(
                      (opt) => opt.value,
                    );

                    if (formData?.combo_type === "Normal") {
                      // Only keep the first selected value
                      selectedValues = selectedValues.slice(0, 1);
                    }

                    setSelectedSubjects(selectedValues);
                    setFormData((prev) => ({
                      ...prev,
                      subjects: selectedValues,
                    }));
                    setDAlert(false);
                    handleSubjectFilter(selectedValues);
                  }}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderRadius: "50px",
                      borderColor: "black",
                      boxShadow: state.isFocused
                        ? "0 0 0 5px rgba(86, 160, 239, 0.4)"
                        : "none",

                      "&:hover": {
                        borderColor: "black",
                      },
                    }),
                    multiValue: (base) => ({
                      ...base,
                      borderRadius: "30px",
                    }),
                  }}
                />
              </div>

              {dAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="subject-filter-select">
                  Subject Filter
                </label>
                <Select
                  isMulti
                  name="subjectFilters"
                  options={subjectFilterOptions.map((item) => ({
                    value: item.id,
                    label: item.title,
                  }))}
                  value={subjectFilterOptions
                    .filter((item) => selectedFilter.includes(item.id))
                    .map((item) => ({
                      value: item.id,
                      label: item.title,
                    }))}
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions.map((opt) => opt.value);

                    setSelectedFilter(selectedIds); // still keep this if you need local state
                    setFormData((prev) => ({
                      ...prev,
                      subjectFilters: selectedIds, // ✅ add to formData
                    }));
                  }}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderRadius: "50px",
                      borderColor: "black",
                      boxShadow: state.isFocused
                        ? "0 0 0 5px rgba(86, 160, 239, 0.4)"
                        : "none", // Blue shadow when focused
                      "&:hover": {
                        borderColor: "rgba(0, 0, 0, 0.4)",
                      },
                    }),
                    multiValue: (base) => ({
                      ...base,
                      borderRadius: "30px",
                    }),
                  }}
                />
              </div>
            </div>

            {/* <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="simple-select">
                  Attempt
                </label>
                <select
                  className="form-control"
                  id="simple-select"
                  name="attempt"
                  required
                  value={formData.attempt} // ✅ use formData.attempt
                  onChange={handleInputChange} // ✅ reuse your generic handler
                >
                  <option value="">Select Attempt</option>
                  {attempts.map((att, i) => (
                    <option key={i} value={att.id}>
                      {att.title}
                    </option>
                  ))}
                </select>
              </div>

              {aAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div> */}

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="batchwings">
                  Select Batch Wings
                </label>
                <select
                  className="form-control"
                  id="batchwings"
                  name="batchwings" // matches formData key
                  required
                  value={formData.batchwings}
                  onChange={handleInputChange}
                >
                  <option value="">Select Batch Wings</option>
                  {Array.isArray(batchwings) &&
                    batchwings.map((wing, i) => (
                      <option key={i} value={wing.id}>
                        {wing.title} {/* Use title, not name */}
                      </option>
                    ))}
                </select>

                {fAlert && (
                  <div>
                    <span style={{ color: "red" }}>*required</span>
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="simple-select">
                  Select Batch
                </label>
                <Select
                  isMulti
                  name="batches"
                  options={batches} // Always rendered, even if empty
                  value={batches.filter((item) =>
                    formData.batch.includes(item.value),
                  )}
                  onChange={(selectedOptions) => {
                    const selectedBatchIds = selectedOptions.map(
                      (opt) => opt.value,
                    );
                    setFormData((prev) => ({
                      ...prev,
                      batch: selectedBatchIds,
                    }));
                  }}
                  placeholder="Select Batch (choose Batch Wings first)"
                  noOptionsMessage={() =>
                    formData.batchwings
                      ? "No batches available for this wing"
                      : "Please select a batch wing first"
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderRadius: "50px",
                      borderColor: "black",
                      boxShadow: state.isFocused
                        ? "0 0 0 5px rgba(86, 160, 239, 0.4)"
                        : "none",
                      "&:hover": {
                        borderColor: "rgba(0, 0, 0, 0.4)",
                      },
                    }),
                    multiValue: (base) => ({
                      ...base,
                      borderRadius: "30px",
                    }),
                  }}
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            {/* <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="sku">
                  SKU
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="sku"
                  name="sku"
                  value={formData.sku}
                  onChange={(e) => {
                    handleInputChange(e);
                    setFAlert(false); // Optional: for showing/hiding alerts
                  }}
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div> */}

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="title">
                  Title
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={(e) => {
                    handleInputChange(e); // Your reusable input handler
                    setFAlert(false); // Optional: alert handling
                  }}
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="duration">
                  Duration
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="duration"
                  name="duration"
                  value={formData.duration}
                  onChange={(e) => {
                    handleInputChange(e); // universal handler updates formData
                    setFAlert(false); // optional alert handling
                  }}
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="akshare">
                  AK Share (%)
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="akshare"
                  name="akshare"
                  value={formData.akshare}
                  onChange={(e) => {
                    handleInputChange(e); // universal handler
                    setFAlert(false); // optional alert
                  }}
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label
                  class="text-dark"
                  htmlFor="simple-select-payment-gateway"
                >
                  Payment Gateway
                </label>
                <select
                  className="form-control"
                  id="simple-select-payment-gateway"
                  name="payment_gateway"
                  value={formData.payment_gateway}
                  onChange={(e) => {
                    handleInputChange(e); // Updates formData
                    setGatewayAlert(false); // Optional alert reset
                  }}
                  required
                >
                  <option value="">Select Payment Gateway</option>
                  <option value="Razorpay">Razorpay</option>
                  <option value="PhonePe">PhonePe</option>
                </select>
              </div>

              {gatewayAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="simple-select-order-template">
                  Order Mail Template
                </label>
                <select
                  className="form-control"
                  id="simple-select-order-template"
                  name="ordermailtemplate"
                  value={formData.ordermailtemplate}
                  onChange={(e) => handleInputChange(e)}
                  required
                >
                  <option value="" disabled>
                    Select a template
                  </option>
                  {orderTemplates.length > 0 ? (
                    orderTemplates.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.title}
                      </option>
                    ))
                  ) : (
                    <option disabled>No templates available</option>
                  )}
                </select>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="simple-select-order-template">
                  Shipping Mail Template
                </label>
                <select
                  className="form-control"
                  id="simple-select-shipping-template"
                  name="shippingmailtemplate"
                  value={formData.shippingmailtemplate}
                  onChange={(e) => handleInputChange(e)}
                  required
                >
                  <option value="" disabled>
                    Select a template
                  </option>
                  {shippingTemplates.length > 0 ? (
                    shippingTemplates.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.title}
                      </option>
                    ))
                  ) : (
                    <option disabled>No templates available</option>
                  )}
                </select>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="simple-select-language">
                  Language
                </label>
                <select
                  className="form-control"
                  id="simple-select-language"
                  name="language"
                  value={formData.language}
                  onChange={(e) => handleInputChange(e)} // Update formData
                  required
                >
                  <option value="">Select Language</option>
                  {languages.map((lang, index) => (
                    <option key={index} value={lang}>
                      {lang}
                    </option>
                  ))}
                </select>
              </div>

              {langAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-sm-6 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="simple-select-test-series">
                  Test Series
                </label>
                <select
                  className="form-control"
                  id="simple-select-test-series"
                  name="testSeries"
                  value={formData.testSeries}
                  onChange={handleInputChangeTestSeries} // This will handle updating formData
                >
                  <option value="">Select Test Series</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>

            {formData.testSeries === "Yes" && (
              <div className="col-12 col-sm-6 col-md-4">
                <div className="form-group mt-3">
                  <label className="text-dark" htmlFor="test-series-select">
                    Select Test Series Batch
                  </label>
                  <select
                    className="form-control"
                    id="test-series-select"
                    name="selectedSeriesId"
                    value={formData.selectedSeriesId}
                    onChange={handleSeriesSelection}
                  >
                    <option value="">Select Batch</option>
                    {testSeriesOptions.map((series) => (
                      <option key={series.id} value={series.id}>
                        {series.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="cashback">
                  Cashback Amount
                </label>
                <div
                  className="input-container"
                  style={{ position: "relative" }}
                >
                  <input
                    type="text"
                    className="form-control"
                    id="cashback"
                    name="cashback"
                    value={formData.cashback}
                    onChange={handleInputChange}
                    required
                    style={{
                      paddingLeft: "30px", // Padding to make room for the icon
                      paddingRight: "10px", // Padding on the right side to make room for the border
                    }}
                  />
                  <span
                    className="fa fa-rupee-sign"
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "18px",
                    }}
                  ></span>
                </div>
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            {/* <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="demoLink1">
                  Demo Link
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="demoLink1"
                  name="demoLink1"
                  value={formData.demoLink1}
                  onChange={handleInputChange} // This will handle updating formData
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div> */}
            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="demoLink1">
                  Demo Link
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="demoLink1"
                  name="demoLink1"
                  value={formData.demoLink1}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {fAlert && !formData.demoLink1 && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="demoLink2">
                  Blue Tag
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="demoLink2"
                  name="demoLink2"
                  value={formData.demoLink2}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {fAlert && !formData.demoLink2 && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="demoLink3">
                  Views
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="demoLink3"
                  name="demoLink3"
                  value={formData.demoLink3}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {fAlert && !formData.demoLink3 && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="demoLink4">
                  Validity
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="demoLink4"
                  name="demoLink4"
                  value={formData.demoLink4}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {fAlert && !formData.demoLink4 && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="googlesheetdetails">
                  Google Sheet Details
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="googlesheetdetails"
                  name="googlesheetdetails"
                  value={formData.googlesheetdetails}
                  onChange={handleInputChange} // This will handle updating formData
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="discount">
                  Discount Amount
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="discount"
                  name="discount"
                  value={formData.discount}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {fAlert && !discount && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="offer_type">
                  Offer Type
                </label>
                <select
                  className="form-control"
                  id="offer_type"
                  name="offer_type"
                  value={formData.offer_type}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Offer Type</option>
                  <option value="Amount">Amount</option>
                  <option value="Percent">Percent</option>
                </select>
              </div>

              {fAlert && !formData.offer_type && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="value">
                  Offer Value
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="value"
                  name="value"
                  value={secondFormData.value}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {fAlert && !secondFormData.value && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="short_description">
                  Short Description
                </label>
                <textarea
                  className="form-control"
                  id="short_description"
                  name="short_description"
                  rows="1"
                  value={formData.short_description}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>
              {fAlert && !formData.short_description && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="value">
                  Apple Product ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="apple_product_id"
                  name="apple_product_id"
                  value={formData.apple_product_id}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {fAlert && !formData.apple_product_id && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="value">
                  Apple ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="apple_id"
                  name="apple_id"
                  value={formData.apple_id}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {fAlert && !formData.apple_id && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="color">
                  Select Color
                </label>

                <input
                  type="color"
                  className="form-control form-control-color"
                  id="selectedColor"
                  name="selectedColor"
                  value={formData.selectedColor}
                  onChange={handleInputChange}
                  title="Choose your color"
                  style={{ height: "45px", width: "100%" }}
                  required
                />
              </div>

              {fAlert && !formData.selectedColor && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>
            <div className="col-6 mt-4">
              <label style={{ fontSize: "16px" }} className="text-dark mb-2">
                Select Amenities
              </label>
              <div style={{ position: "relative", zIndex: 9999 }}>
                <MultiSelect
                  disableSearch
                  options={amenities.map((item) => ({
                    label: item.title,
                    value: item.id,
                  }))}
                  value={formData.selected_amenities}
                  onChange={(data) => {
                    setFormData((prev) => ({
                      ...prev,
                      selected_amenities: data,
                    }));
                  }}
                  labelledBy="Select Amenities"
                />
              </div>

              {fAlert && formData.selected_amenities.length === 0 && (
                <div
                  style={{
                    marginTop: "10px",
                    color: "#d9534f",
                    fontSize: "13px",
                  }}
                >
                  *Please select at least one amenity
                </div>
              )}
            </div>
            {/* <div className="col-12 mt-4">
              <label
                style={{ fontSize: "16px" }}
                className="text-dark mb-2"
                htmlFor="color"
              >
                Select Amenities
              </label>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                  gap: "12px 40px",
                }}
              >
                {amenities?.map((amenity) => {
                  const isSelected = formData.amenitiesIds.includes(amenity.id);

                  return (
                    <div
                      key={amenity.id}
                      onClick={() => handleAmenityChange(amenity)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "6px 8px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        backgroundColor: isSelected ? "#eef4ff" : "transparent",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleAmenityChange(amenity)}
                        style={{
                          marginRight: "10px",
                          width: "16px",
                          height: "16px",
                          accentColor: "#4a6cf7",
                          cursor: "pointer",
                        }}
                      />

                      <span
                        style={{
                          fontSize: "14px",
                          color: isSelected ? "#1a3fbf" : "#444",
                          fontWeight: isSelected ? "500" : "400",
                        }}
                      >
                        {amenity.title}
                      </span>
                    </div>
                  );
                })}
              </div>

              {fAlert && formData.amenitiesIds.length === 0 && (
                <div
                  style={{
                    marginTop: "10px",
                    color: "#d9534f",
                    fontSize: "13px",
                  }}
                >
                  *Please select at least one amenity
                </div>
              )}
            </div> */}
            <div style={{ marginTop: "30px" }}>
              <Grid container spacing={2}>
                {faculty.length >= 1 && (
                  <Grid item xs={12}>
                    <table
                      style={{
                        width: "100%",
                        border: "1px black solid",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead>
                        <tr>
                          <th style={headerStyle}>Sr.No</th>
                          <th style={headerStyle}>Faculty</th>
                          <th style={headerStyle}>Faculty Share</th>
                          <th style={headerStyle}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {faculty.map((v, i) => (
                          <tr key={i}>
                            <td style={cellStyle}>{i + 1}</td>
                            <td style={cellStyle}>{v.fName}</td>
                            <td style={cellStyle}>{v.fshare}</td>
                            <td style={cellStyle}>
                              <input
                                style={{
                                  backgroundColor: "red",
                                  borderRadius: "10%",
                                  border: "none",
                                  padding: "10px",
                                  color: "white",
                                }}
                                type="button"
                                value="Delete"
                                onClick={() => handleDelete(i)}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Grid>
                )}
              </Grid>

              {!visible && (
                <GridItem xs={12} sm={12} md={12}>
                  <Button
                    onClick={() => setVisible(true)}
                    className="btn-round"
                    color="success"
                  >
                    Add Faculty
                  </Button>
                </GridItem>
              )}

              <Modal
                visible={visible}
                width="700"
                height="175"
                effect="fadeInUp"
                onClickAway={() => setVisible(false)}
              >
                <GridContainer
                  style={{ paddingLeft: "5px", paddingTop: "20px" }}
                >
                  <GridItem xs={12} sm={12} md={5}>
                    <FormControl fullWidth>
                      <label>Faculty</label>
                      <select
                        style={{ padding: "11px" }}
                        name="facultyId"
                        value={facultyId}
                        onChange={(e) => {
                          setFacultyId(e.target.value);
                          const selected = facultyArr.find(
                            (f) => parseInt(f.id) === parseInt(e.target.value),
                          );
                          if (selected) setFacultyWithName(selected.name);
                        }}
                      >
                        <option value="">Select</option>
                        {facultyArr.map((v, i) => (
                          <option key={i} value={v.id}>
                            {v.name}
                          </option>
                        ))}
                      </select>
                    </FormControl>
                    {bAlert && (
                      <div>
                        <span style={{ color: "red" }}>*required</span>
                      </div>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText="Faculty Share"
                      id="float"
                      inputProps={{
                        type: "float",
                        required: true,
                        value: facultyshare,
                        onChange: (e) => setFacultyshare(e.target.value),
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={2}>
                    <Button
                      style={{ marginTop: "20px" }}
                      onClick={handleAdd}
                      className="btn-round"
                      color="success"
                    >
                      Add
                    </Button>
                  </GridItem>
                </GridContainer>
              </Modal>
            </div>

            <div className="col-12">
              <div className="form-group mt-3">
                <label
                  class="text-dark"
                  htmlFor="courseDetails"
                  className="font-weight-bold"
                  style={{ fontSize: "16px", marginBottom: "10px" }}
                >
                  Course Details
                </label>

                <CKEditor
                  editor={ClassicEditor}
                  data={courseDetails}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setCourseDetails(data);
                  }}
                  config={{
                    toolbar: [
                      "heading",
                      "|",
                      "alignment",
                      "|",
                      "bold",
                      "italic",
                      "underline",
                      "fontColor",
                      "fontBackgroundColor",
                      "|",
                      "bulletedList",
                      "numberedList",
                      "highlight",
                      "|",
                      "insertTable",
                      "blockQuote",
                      "|",
                      "undo",
                      "redo",
                    ],
                    table: {
                      contentToolbar: [
                        "tableColumn",
                        "tableRow",
                        "mergeTableCells",
                      ],
                    },
                    alignment: {
                      options: ["left", "center", "right", "justify"],
                    },
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-4 my-3">
                <label htmlFor="img">Upload Image</label>
                <br />
                <input
                  id="img"
                  name="img"
                  onChange={handleFile}
                  accept="image/*"
                  type="file"
                  required={true}
                  className="form-control"
                />
                {/* <span style={{ color: "red" }}>
      Image should be 750px X 180px.
    </span> */}
              </div>

              {/* <div className="col-12 col-sm-12 col-md-4 mb-3">
                <label htmlFor="thumb">Thumb Image</label>
                <br />
                <input
                  id="thumb"
                  name="thumb"
                  onChange={handleFile}
                  accept="image/*"
                  type="file"
                  className="form-control"
                />
              </div> */}

              {/* Image preview */}
              {imgPreview && (
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={imgPreview}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "150px",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              )}
            </div>

            {requiredFields && (
              <>
                <div style={{ color: "red", margin: "10px 0px" }}>
                  * Please fill in all the required fields
                </div>
              </>
            )}

            <div className="col-12 my-4">
              <div className="d-flex justify-content-start gap-3">
                <button
                  className="btn btn-dark"
                  type="submit"
                  style={{ borderRadius: "8px", padding: "6px 24px" }}
                  onClick={handleSubmit1}
                >
                  Submit
                </button>

                <button
                  className="btn btn-dark"
                  type="button"
                  style={{ borderRadius: "8px", padding: "6px 24px" }}
                  onClick={handleCancel1}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      {isSubmitted && (
        <div className="mt-4">
          <div
            className="card shadow-sm"
            style={{ borderRadius: "20px", padding: "24px" }}
          >
            <h6 className="card-title mb-4">Update Submitted Data</h6>
            <form onSubmit={handleSecondFormSubmit}>
              <div className="row g-3">
                <div className="col-12 col-md-4">
                  <div className="form-group">
                    <label htmlFor="attempt">Attempt</label>
                    <select
                      id="attempt"
                      name="attempt_id"
                      className="form-control"
                      value={secondFormData.attempt_id}
                      onChange={handleSecondInputChange}
                    >
                      <option value="">Select Attempt</option>
                      {attemptOptions.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="form-group">
                    <label htmlFor="sku">SKU</label>
                    <input
                      type="text"
                      className="form-control"
                      id="sku"
                      name="sku"
                      value={secondFormData.sku}
                      onChange={handleSecondInputChange}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="form-group">
                    <label htmlFor="price">Price</label>
                    <input
                      type="number"
                      className="form-control"
                      id="price"
                      name="price"
                      value={secondFormData.price}
                      onChange={handleSecondInputChange}
                    />
                  </div>
                </div>

                <div className="col-12 mt-3">
                  <div className="d-flex justify-content-start gap-3">
                    <button
                      className="btn btn-success"
                      type="submit"
                      style={{
                        borderRadius: "8px",
                        padding: "6px 24px",
                      }}
                      onClick={handleSecondFormSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {variants.length > 0 && (
            <div className="mt-4">
              <h5>Submitted Variants</h5>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th style={{ width: "20%" }}>Attempt</th>
                    <th style={{ width: "20%" }}>SKU</th>
                    <th style={{ width: "20%" }}>Price</th>
                    <th style={{ width: "20%" }}>Edit</th>
                    <th style={{ width: "20%" }}>Cancel</th>
                  </tr>
                </thead>
                <tbody>
                  {variants.map((variant, index) => (
                    <tr key={index}>
                      <td>
                        {attemptOptions.find(
                          (opt) => opt.id === variant.attempt_id,
                        )?.title || "-"}
                      </td>

                      <td>{variant.sku || "-"}</td>
                      <td>₹{variant.price || 0}</td>
                      <td>
                        <button
                          className="btn btn-warning btn-sm w-75"
                          onClick={() => handleEdit(index)}
                        >
                          Edit
                        </button>
                      </td>
                      <td>
                        <button
                          className="btn btn-danger btn-sm w-75"
                          onClick={() => handleDelete(variant.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NewAddCourseMaster;
